import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
//import { ICellRendererParams } from "@ag-grid-enterprise/all-modules";
import { ICellRendererParams } from 'ag-grid-community'; 



@Component({
    selector: 'app-button-renderer',
    templateUrl: './button-renderer.component.html',
    styleUrls: ['./button-renderer.component.scss'],
    standalone: false
})
export class ButtonRendererComponent implements ICellRendererAngularComp {

    params: any;

    get buttonText(): string {
        if (this.params == null || this.params.buttonText == null) return "Click";
        return this.params.buttonText;
    }

    constructor() { }


    agInit(params: ICellRendererParams) {
        this.params = params;

        params.eGridCell?.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === ' ' || event.key === 'Enter') {
                event.preventDefault();
                this.params.action(this.params.data);
            }
        });
    }

    refresh(params: any): boolean {
        return true;
    }


    click(event: MouseEvent): void {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        this.params.action(this.params.data);
    }
}
